import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteUsersService = async (userId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/users/${userId}`);
};

export default deleteUsersService;
